module.exports = __webpack_public_path__ + "UMB-RMR Trustee Transfer Form.pdf";